import IconeAjuda from '@/global/components/IconeAjuda'
import { Label } from '@/global/components/ui/label'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import Grid from 'global/components/ui/Grid'
import { ArrowDownAZIcon, ArrowDownWideNarrowIcon } from 'lucide-react'
import { AcoesField } from './AcoesField'
import { CondicoesField } from './CondicoesField'

/**
 * Campos da rotina; precisa estar dentro do formulário do diálogo. Alcance e
 * momento de execução são condições — sem execução, a rotina é manual.
 */
export function RotinaForm() {
    return (
        <Grid container>
            <Grid item xs={12}>
                <FormField name="nome" label="Nome" required />
            </Grid>

            <Grid item xs={12} className="inline-flex justify-between">
                <Label className="my-auto text-lg">Se (condição)</Label>
                <Label className="text-muted-foreground">
                    Prioriza alcance e execução
                    <ArrowDownAZIcon className="size-4" />
                </Label>
            </Grid>
            <Grid item xs={12}>
                <CondicoesField />
            </Grid>

            <Grid item xs={12}>
                <div className="h-4" />
            </Grid>

            <Grid item xs={12} className="inline-flex justify-between">
                <Label className="my-auto text-lg">Então (ação)</Label>
                <Label className="text-muted-foreground">
                    Executa na ordem definida
                    <ArrowDownWideNarrowIcon className="size-4" />
                </Label>
            </Grid>
            <Grid item xs={12}>
                <AcoesField />
            </Grid>

            <Grid item xs={12}>
                <div className="h-4" />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormFieldCheckbox
                    name="notificarFalha"
                    label="Notificar no caso de falha"
                    endAdornment={
                        <IconeAjuda>
                            Quando uma ação falhar, os administradores e os
                            gestores do funcionário recebem uma notificação no
                            site.
                        </IconeAjuda>
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormFieldCheckbox
                    name="continuarComFalha"
                    label="Continuar mesmo com falha"
                    endAdornment={
                        <IconeAjuda>
                            Executa as ações seguintes mesmo depois de uma
                            falhar. Desmarcado, as ações seguintes ficam
                            pendentes até o disparo ser reexecutado.
                        </IconeAjuda>
                    }
                />
            </Grid>
        </Grid>
    )
}
